import { isDefined } from '@sgme/fp';
import { quoteOrTabRemoved } from 'epic/workspace/common/tabs/tabsEpics/quoteOrTabRemoved';
import { ofType } from 'redux-observable';
import { combineLatest, merge, of } from 'rxjs';
import { filter, mergeMap, takeUntil, withLatestFrom } from 'rxjs/operators';
import { ordersBasketFormAllBookingResultsReceivedThunk } from 'state/orders-basket/thunks';
import type { EpicWithThunk } from 'state/state.common';

// Epic for ordersBasket booking results
export function bookingResultsEpic(): EpicWithThunk {
  return (action$, state$) =>
    action$.pipe(
      ofType('BOOKING_ACKED'),
      filter(action => action.workspace === 'ordersBasket'),
      withLatestFrom(state$),
      mergeMap(([{ formId, tabId }, _]) => {
        // Exceptional cases
        const quoteOrTabRemoved$ = quoteOrTabRemoved(action$, tabId, formId, state$);

        // Happy use cases
        const quoteReceived$ = action$.pipe(
          ofType('ORDERS_BASKET_FORM_QUOTED'),
          filter(a => a.formId === formId),
        );
        const tradeAuthGranted$ = action$.pipe(
          ofType('ORDERS_BASKET_FORM_TRADE_AUTH_GRANTED'),
          filter(a => a.formId === formId),
        );
        const tradeExecuted$ = action$.pipe(
          ofType('ORDERS_BASKET_FORM_TRADED'),
          filter(a => a.formId === formId),
        );

        return combineLatest([quoteReceived$, tradeAuthGranted$, tradeExecuted$]).pipe(
          withLatestFrom(state$),
          filter(([actions, _]) => actions.every(a => isDefined(a) && a.formId === formId)),
          mergeMap(([_, __]) => {
            return of(ordersBasketFormAllBookingResultsReceivedThunk(formId));
          }),
          takeUntil(merge(quoteOrTabRemoved$)),
        );
      }),
    );
}
